import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const DestinationService = {
  getList: async () => {
    const response = await apiService.get("/destinationcountries");
    console.log(response);
    return response.data;
  },

  createDestination: async (payload) => {
    const response = await apiService.post("/destinationcountries", payload);
    return response.data;
  },

  // Fetch single destination detail
  getDetail: async (id) => {
    const response = await apiService.get(`/destinationcountries/${id}`);
    return response.data;
  },
  getBySlug: async (id) => {
    const response = await apiService.get(
      `/destinationcountries/slug?slug=${id}`
    );
    return response.data;
  },
  updateDestination: async (id, payload) => {
    const response = await apiService.put(
      `/destinationcountries/${id}`,
      payload
    );
    return response.data;
  },

  deleteDestination: async (id, payload) => {
    const response = await apiService.delete(
      `/destinationcountries/${id}`,
      payload
    );
    return response.data;
  },
};
export default DestinationService;
